<template>
<div class="container-fluid">
    <div class="page-container">
        <div class="form-image-container">
            <div class="form-container">
                <a href="/"><img src="../assets/logo/appLogo.svg" alt=""></a>
                <h2 class="form-title">Membership Login</h2>

                <p>Please login to continue.</p>
                
                <!-- Username -->
                <div class="form-group">
                    <label for="username">Username</label>
                    <input id="username" v-model="username" type="text" placeholder="Enter your username"
                        required />
                </div>

                <!-- Password with toggle -->
                <div class="form-group password-field">
                    <label for="password">Password</label>
                    <div class="password-wrapper">
                        <input id="password" v-model="password" :type="showPassword ? 'text' : 'password'"
                            placeholder="Enter your password" required />
                        <button type="button" class="toggle-btn" @click="togglePassword">
                            <EyeOff v-if="showPassword" style="color: #30373D;" />
                            <Eye v-else style="color: #30373D;" />
                        </button>
                    </div>
                </div>
                <button class="recover-password" @click="resetPassword">Recover Password</button>
                <!-- Submit -->
                <!-- <button type="submit" class="submit-btn">Sign in</button> -->
                <button class="submit-btn" @click="handleLogin" :disabled="isSubmitButtonDisabled" v-if="!loading">Sign in</button>
                <button class="submit-btn" type="button" v-if="loading">
                    <i class="fas fa-spinner fa-spin"></i>
                </button>
                
                <div class="login-info">
                    <OctagonAlert />
                    <p>First-time users must register to access the members-only area. Click the Member Registration
                        link below and enter your Member Number, First Name, and Last Name as shown on your account
                        statement. After validating your account, you’ll create a personal Username and Password, which
                        you’ll only need to set up once.</p>
                </div>
                <button class="register-btn" @click="handleSignup">Member Registration</button>
            </div>
            <div class="image-container">
                <div class="logo">
                    <img src="../assets/logo/appLogo.svg" alt="">
                </div>
                <h2>“Courts are immaculate, coaching is world‑class, and the community is genuinely welcoming.”</h2>
                <p>— Fatima R.</p>
                <span>Member since 2018</span>
                <img src="../assets/images/login/login.png" alt="">
            </div>
        </div>
    </div>
</div>
</template>

<script setup>
/* eslint-disable */
import { ref,  computed, onBeforeMount, onMounted, onBeforeUpdate, onUpdated } from "vue";
import router from "@/router";
import { Eye, EyeOff, OctagonAlert } from "lucide-vue-next";
import axios from 'axios';
import { useRoute } from 'vue-router'

let username = ref('');
//let membership = ref('');
let password = ref('');
let loading = ref(false);
const registerEventId = ref('')
const registerTournamentId = ref('')

const showPassword = ref(false);

// In setup function
const route = useRoute()

onMounted( async () => {
    registerEventId.value = route.params.event
    //registerTournamentId.value = route.params.tournament
    console.log(registerEventId.value)
});

function togglePassword() {
    showPassword.value = !showPassword.value;
}

const isSubmitButtonDisabled = computed(() => {
    return (
        username.value === '' ||
        password.value === '' 
    );
    }
);

const resetPassword = () => {
    router.push('/reset-password')
}
const handleLogin = async () => {
    try {

        loading.value = true
        // Make the signup API request
        const response = await axios.post('/login.php', {
            username: username.value,
            password: password.value,
        });
        
        loading.value = false

        let token = response.data.token;
        await localStorage.setItem("userid", response.data.data.id)
        await localStorage.setItem("username", response.data.data.username)
        await localStorage.setItem("email_address", response.data.data.email_address)
        await localStorage.setItem("user_role", response.data.data.user_role)
        await localStorage.setItem("member_id", response.data.data.membership_number)
        await localStorage.setItem("jwt_token", token)

        if (registerEventId.value === 'registerEvent') {
            window.location.href = "/#club-events";
            return;
        }
        if (registerEventId.value === 'registerTournament') {
            window.location.href = "/tournaments#club-tournament";
            return;
        }

        if (registerEventId.value === 'bookCourt') {
            window.location.href = "/court-booking#court-availability";
            return;
        }

        router.push("/dashboard")
            
    } catch (error) {
        alert(error.response ? error.response.data.message : error.message);
        console.error('Error:', error.response ? error.response.data : error.message);
        loading.value = false
    }
}

const handleSignup = () => {
    router.push('/register');
};
</script>

<style lang="scss" scoped>
.page-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    background-color: #F6F6F6;
    gap: 2rem;
    margin: auto;

    .form-image-container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        //align-items: center;
        margin: auto;
        min-height: 100vh;

        .form-container {
            width: 40%;
            padding-left: 140px;
            padding-top: 120px;

        }
            
            .form-title {
                text-align: center;
                margin-top: 20px;
                margin-bottom: 20px;
                font-size: 24px;
                color: #000000;
                font-weight: 700;
                font-family: "Open Runde", sans-serif;
            }

            p {
                text-align: center;
                margin-bottom: 20px;
                color: #707B81;
                font-size: 16px;
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
            }

            .form-group {
                margin-bottom: 10px;
                display: flex;
                flex-direction: column;
            }

            .form-group:last-of-type {
                margin-bottom: 5px;
            }

            label {
                margin-bottom: 6px;
                font-weight: 500;
                font-size: 15px;
                color: #30373D;
                text-align: left;
                width: 100%;
            }

            input {
                padding: 10px 20px;
                border: 1px solid #D1D1D1;
                border-radius: 14px;
                font-size: 16px;
            }

            input:focus {
                border-color: #4a90e2;
                outline: none;
            }

            .password-wrapper {
                display: flex;
                align-items: center;
                position: relative;
            }

            .password-wrapper input {
                flex: 1;
                padding-right: 60px;
            }

            .toggle-btn {
                position: absolute;
                right: 10px;
                background: none;
                border: none;
                font-size: 13px;
                color: #4a90e2;
                cursor: pointer;
            }

            .toggle-btn:hover {
                text-decoration: underline;
            }

            .recover-password {
                background-color: none;
                border: none;
                color: #4a90e2;
                font-size: 14px;
                text-align: right;
                margin-bottom: 2rem;
                width: 100%;
            }

            .submit-btn {
                width: 100%;
                padding: 14px 12px;
                background: #ED4E24;
                border: 1px solid #eb7758;
                color: #fff;
                font-size: 16px;
                font-weight: 600;
                border-radius: 60px;
                cursor: pointer;
                transition: background 0.3s ease;
            }

            .register-btn {
                width: 100%;
                padding: 14px 12px;
                background: white;
                border: 1px solid #00000033;
                color: #000000CC;
                font-size: 16px;
                font-weight: 600;
                border-radius: 60px;
                cursor: pointer;
                margin-top: 0.2rem;
                transition: background 0.3s ease;
                margin-bottom: 6.2rem;
            }

            .submit-btn:hover {
                background: #eb7758;
            }

            .login-info {
                display: flex;
                justify-content: start;
                align-items: start;
                gap: 20px;
                margin-top: 30px;

                p {
                    font-size: 14px;
                    color: #555555;
                    font-weight: 400;
                    font-family: "Open Runde", sans-serif;
                    max-width: 80%;
                    text-align: left;
                }
            }
    }

        .image-container {
            width: 50%;
            position: relative;
            padding-top: 20px;
            padding-bottom: 20px;
            
        }

        .logo {
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 1;
        }

        .logo img {
            max-height: 45px;
        }

        .image-container img {
            width: 100%;
            height: 100%;
            border-radius: 16px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            /* filter: blur(4px); */
            position: relative;
            z-index: 0;
            /* 👈 send behind */
        }

        .image-container h2,
        .image-container p,
        .image-container span {
            position: absolute;
            z-index: 1;
            /* 👈 bring forward */
            font-family: "Open Runde", sans-serif;
            color: #fff;
        }

        .image-container h2 {
            bottom: 30px;
            left: 45%;
            font-size: 28px;
            font-weight: 500;
            transform: translate(-50%, -50%);
            text-align: left;
            width: 80%;
        }

        .image-container p {
            bottom: 20px;
            left: 45%;
            font-size: 14px;
            font-weight: 400;
            transform: translate(-50%, -50%);
            text-align: left;
            width: 80%;
        }

        .image-container span {
            bottom: 18px;
            left: 45%;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFFCC;
            transform: translate(-50%, -50%);
            text-align: left;
            width: 80%;
        }

    }

@media (max-width: 768px) {
    .page-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 100%;
        background-color: #F6F6F6;
        gap: 2rem;
        margin: auto;
        padding: 20px 10px 20px 10px;

        .form-image-container {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: auto;

            .form-container {
                width: 100%;
                padding-left: 0px;
                padding-top: 80px;

                .form-title {
                    text-align: center;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    font-size: 20px;
                    color: #000000;
                    font-weight: 700;
                    font-family: "Open Runde", sans-serif;
                }

                p {
                    text-align: center;
                    margin-bottom: 10px;
                    color: #707B81;
                    font-size: 16px;
                    font-weight: 400;
                    font-family: "Open Runde", sans-serif;
                }

                .form-group {
                    margin-bottom: 10px;
                    display: flex;
                    flex-direction: column;
                }

                .form-group:last-of-type {
                    margin-bottom: 5px;
                }

                label {
                    margin-bottom: 6px;
                    font-weight: 500;
                    font-size: 15px;
                    color: #30373D;
                    text-align: left;
                    width: 100%;
                }

                input {
                    padding: 12px 24px;
                    border: 1px solid #D1D1D1;
                    border-radius: 14px;
                    font-size: 16px;
                }

                input:focus {
                    border-color: #4a90e2;
                    outline: none;
                }

                .password-wrapper {
                    display: flex;
                    align-items: center;
                    position: relative;
                }

                .password-wrapper input {
                    flex: 1;
                    padding-right: 60px;
                }

                .toggle-btn {
                    position: absolute;
                    right: 10px;
                    background: none;
                    border: none;
                    font-size: 13px;
                    color: #4a90e2;
                    cursor: pointer;
                }

                .toggle-btn:hover {
                    text-decoration: underline;
                }

                .recover-password {
                    background-color: none;
                    border: none;
                    color: #4a90e2;
                    font-size: 14px;
                    text-align: right;
                    margin-bottom: 2rem;
                    width: 100%;
                }

                .submit-btn {
                    width: 100%;
                    padding: 14px 12px;
                    background: #ED4E24;
                    border: 1px solid #eb7758;
                    color: #fff;
                    font-size: 16px;
                    font-weight: 600;
                    border-radius: 60px;
                    cursor: pointer;
                    transition: background 0.3s ease;
                }

                .register-btn {
                    width: 100%;
                    padding: 14px 12px;
                    background: white;
                    border: 2px solid #00000033;
                    color: #000000CC;
                    font-size: 16px;
                    font-weight: 600;
                    border-radius: 60px;
                    cursor: pointer;
                    margin-top: 10px;
                    transition: background 0.3s ease;
                }

                .submit-btn:hover {
                    background: #eb7758;
                }

                .login-info {
                    display: flex;
                    justify-content: start;
                    align-items: start;
                    gap: 20px;
                    margin-top: 30px;

                    p {
                        font-size: 14px;
                        color: #555555;
                        font-weight: 400;
                        font-family: "Open Runde", sans-serif;
                        max-width: 80%;
                        text-align: left;
                    }
                }
            }

            .image-container {
                display: none;
            }
        }


    }
}
</style>
